import { diff, valid } from 'semver';

export default (version1, version2) => {
  if (!valid(version1) || !valid(version2)) throw new Error('Versions are not valid');

  switch (diff(version1, version2)) {
    case 'major':
    case 'minor':
      return false;
    default:
      return true;
  }
};
